import React, { Fragment } from "react";
import AllRoute from "../router";
import "./App.css";

const App = () => {
  return (
    <Fragment>
      <AllRoute />
    </Fragment>
  );
};

export default App;
